import React, { memo } from 'react';
import PhotoGallery from '../../../shared/components/PhotoGallery/PhotoGallery';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';

const Feed = memo(({
  id,
  title,
}) => (
  <section id={id} className='auto-padding-section mb-6'>
    <ResponsiveHeader className='mb-4' xs='h4' md='h3'>
      {title}
    </ResponsiveHeader>
    <PhotoGallery
      xs={1}
      sm={2}
      lg={3}
      username={'obviously'}
      platform={'instagram'} />
  </section>
));

export default Feed;